import { render, staticRenderFns } from "./CustomRadioInput.vue?vue&type=template&id=73038dc1&scoped=true&"
import script from "./CustomRadioInput.vue?vue&type=script&lang=js&"
export * from "./CustomRadioInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadioInput.vue?vue&type=style&index=0&id=73038dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73038dc1",
  null
  
)

export default component.exports